import { useLocation } from 'react-router-dom';

export const ADMIN_BASE_PATH = '/admin';
export const ADMIN_V1_BASE_PATH = '/v1/admin';
export const ADMIN_V2_BASE_PATH = '/v2/admin';
export const ADMIN_AUTH_PATH = '/admin/auth';
export const ADMIN_V1_AUTH_PATH = '/v1/admin/auth';
export const PATIENT_BASE_PATH = '/s';
export const PATIENT_V2_BASE_PATH = '/v2/s';
const V2_SOCIAL_CALLBACK_FLOW_KEY = 'cyren_v2_social_callback_flow';

export type SocialAuthProvider = 'google' | 'microsoft';

export function isV2Pathname(pathname: string) {
  return pathname.startsWith('/v2/');
}

export function getAdminBasePath(pathname: string) {
  return pathname.startsWith(ADMIN_V2_BASE_PATH) ? ADMIN_V2_BASE_PATH : ADMIN_BASE_PATH;
}

export function getAdminAuthPath(pathname: string) {
  if (pathname.startsWith(ADMIN_V2_BASE_PATH)) {
    return `${ADMIN_V2_BASE_PATH}/auth`;
  }
  if (pathname.startsWith(ADMIN_V1_AUTH_PATH) || pathname.startsWith(ADMIN_V1_BASE_PATH)) {
    return ADMIN_V1_AUTH_PATH;
  }
  return ADMIN_AUTH_PATH;
}

export function getPatientBasePath(pathname: string) {
  return pathname.startsWith(PATIENT_V2_BASE_PATH) ? PATIENT_V2_BASE_PATH : PATIENT_BASE_PATH;
}

export function getV2PatientRedirectPath(pathname: string) {
  if (pathname === PATIENT_BASE_PATH || pathname.startsWith(`${PATIENT_BASE_PATH}/`)) {
    return pathname.replace(/^\/s(?=\/|$)/, PATIENT_V2_BASE_PATH);
  }

  return pathname;
}

export function useAdminBasePath() {
  const { pathname } = useLocation();
  return getAdminBasePath(pathname);
}

export function useIsV2Path() {
  const { pathname } = useLocation();
  return isV2Pathname(pathname);
}

export function useAdminAuthPath() {
  const { pathname } = useLocation();
  return getAdminAuthPath(pathname);
}

export function usePatientBasePath() {
  const { pathname } = useLocation();
  return getPatientBasePath(pathname);
}

export function markV2SocialCallbackFlow(provider: SocialAuthProvider) {
  try {
    window.sessionStorage.setItem(V2_SOCIAL_CALLBACK_FLOW_KEY, provider);
  } catch (error) {
    console.warn('Unable to mark V2 social callback flow', error);
  }
}

export function isV2SocialCallbackFlow(provider: SocialAuthProvider) {
  try {
    return window.sessionStorage.getItem(V2_SOCIAL_CALLBACK_FLOW_KEY) === provider;
  } catch {
    return false;
  }
}

export function clearV2SocialCallbackFlow() {
  try {
    window.sessionStorage.removeItem(V2_SOCIAL_CALLBACK_FLOW_KEY);
  } catch (error) {
    console.warn('Unable to clear V2 social callback flow', error);
  }
}
